import React from "react"

const IconFamily = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
      <path
        fill="#152C4F"
        d="M17.813 13.978a2.813 2.813 0 11-5.627-.002 2.813 2.813 0 015.627.002zm8.943-6.563h-4.762a3.244 3.244 0 00-3.244 3.244v6.131a1.875 1.875 0 001.875 1.875v11.25h7.5v-11.25A1.875 1.875 0 0030 16.79V10.66a3.243 3.243 0 00-3.244-3.244z"
      ></path>
      <path
        fill="#152C4F"
        d="M28.125 3.665a3.751 3.751 0 11-7.5.17 3.751 3.751 0 017.5-.17zM8.006 9.29H3.244a3.245 3.245 0 10.002 6.49 3.245 3.245 0 00-.002-6.49A3.246 3.246 0 000 12.536v4.254a1.875 1.875 0 001.875 1.875L0 24.29h1.875v5.625h7.5V24.29h1.875l-1.875-5.625a1.875 1.875 0 001.875-1.875v-4.256A3.244 3.244 0 008.006 9.29z"
      ></path>
      <path
        fill="#152C4F"
        d="M9.375 5.54a3.75 3.75 0 11-7.498.17 3.75 3.75 0 017.498-.17zm3.75 18.75v5.625h3.75V24.29a1.875 1.875 0 001.875-1.875v-2.887a2.737 2.737 0 00-2.738-2.738h-2.025a2.737 2.737 0 00-2.737 2.738v2.887a1.875 1.875 0 001.875 1.875z"
      ></path>
    </svg>
  )
}

export default IconFamily
